exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tasks[data-v-c41be85e] {\n  padding-left: 2px;\n}\n.tasks .task .task-name[data-v-c41be85e] {\n  display: block;\n  margin-bottom: 0.2rem;\n  line-height: 1.25rem;\n}", ""]);

// exports
